var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanguage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#a2adb8",
    d: "M256,490.7V512c141.4,0,256-114.6,256-256C512,114.6,397.4,0,256,0C114.6,0,0,114.6,0,256c0,141.4,114.6,256,256,256V490.7 v-21.3c-59,0-112.2-23.8-150.9-62.5C66.5,368.2,42.7,315,42.7,256c0-59,23.8-112.2,62.5-150.9C143.8,66.5,197,42.7,256,42.7 c59,0,112.2,23.8,150.9,62.5c38.6,38.7,62.5,91.9,62.5,150.9c0,59-23.8,112.2-62.5,150.8c-38.7,38.6-91.9,62.5-150.9,62.5V490.7z  M256,490.7V512c11,0,21.6-2.4,31.1-6.9c16.8-7.9,29.4-21.7,39-38c14.4-24.6,23-55.8,28.6-91.8c5.6-35.9,7.9-76.6,7.9-119.4 c-0.1-65.2-5.2-125.3-19.6-171.7c-7.3-23.2-16.9-43.2-31-58.7c-7.1-7.7-15.4-14.2-24.9-18.7C277.6,2.4,267,0,256,0 c-11,0-21.6,2.4-31.1,6.9c-16.8,7.9-29.4,21.7-39,38c-14.4,24.6-23,55.8-28.6,91.8c-5.6,35.9-7.9,76.6-7.9,119.4 c0.1,65.2,5.2,125.3,19.6,171.7c7.3,23.2,16.9,43.2,31,58.7c7.1,7.7,15.4,14.2,24.9,18.7c9.5,4.5,20.2,6.9,31.1,6.9V490.7v-21.3 c-5,0-9-1-12.9-2.8c-6.7-3.1-13.7-9.7-20.4-21c-10.1-16.9-18.2-43.9-23.3-76.7C194.3,336,192,297.2,192,256 c-0.1-62.8,5.4-120,17.7-159c6-19.5,13.8-34.1,21.7-42.6c3.9-4.3,7.8-7.1,11.7-9c3.9-1.8,7.9-2.8,12.9-2.8c5,0,9,1,12.9,2.8 c6.7,3.1,13.7,9.7,20.4,21c10.1,16.9,18.2,43.9,23.3,76.7c5.1,32.9,7.4,71.6,7.4,112.8c0.1,62.8-5.4,120-17.7,159 c-6,19.5-13.8,34.1-21.7,42.6c-3.9,4.3-7.8,7.1-11.7,9c-3.9,1.8-7.9,2.8-12.9,2.8V490.7z M42.7,362.7h426.7V320H42.7V362.7z  M42.7,192h426.7v-42.7H42.7V192z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/language.c4c97759a3a30292197453de784959be.svg";
export { ForwardRef as ReactComponent };